import {computed, inject, Injectable, signal} from '@angular/core';
import {AuthStore} from '@auth/data-access';

@Injectable({
	providedIn: 'root',
})
export class SidenavService {
	private readonly authStore = inject(AuthStore);
	public readonly isSidenavAvailable = computed(() => this.authStore.isAuthenticated() && this.authStore.isPermanent());

	private _collapsed = signal<boolean>(true);
	public collapsed = this._collapsed.asReadonly();

	toggleCollapsed(): void {
		this._collapsed.update(state => !state);
		this.saveToLocalStorage();
	}

	setCollapsed(value: boolean): void {
		this._collapsed.set(value);
		this.saveToLocalStorage();
	}

	initFromLocalStorage(): void {
		const savedState = localStorage.getItem('sidenav_collapsed');
		if (savedState) {
			this._collapsed.set(savedState === 'true');
		}
	}

	public saveToLocalStorage(): void {
		localStorage.setItem('sidenav_collapsed', this._collapsed().toString());
	}

	public readonly ActiveGroup = {
		activeGroupId: signal<string | undefined>(undefined),
		onGroupClick: (groupId: string): void => {
			const currentActiveGroupId = this.ActiveGroup.activeGroupId();
			if (currentActiveGroupId === groupId) {
				this.ActiveGroup.activeGroupId.set(undefined);
			} else {
				this.ActiveGroup.activeGroupId.set(groupId);
			}
		},
	};
}
